export const Config = { 
    "APIBaseURL": process.env.REACT_APP_APIBASEURL,
    "WSBaseURL": process.env.REACT_APP_WSBASEURL
};